import React from "react";
import { Modal } from "@mui/material";
import HPBaseModal from "@components/common/HPBaseModal";

interface DisableCustomBaseConfirmDialogProps {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

const DisableCustomBaseConfirmDialog: React.FC<DisableCustomBaseConfirmDialogProps> = ({
  open,
  onCancel,
  onConfirm,
}) => {
  if (!open) return null;

  return (
    <Modal
      open={open}
      onClose={onCancel}
      sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
    >
      <div style={{ width: 440, outline: "none" }}>
        <HPBaseModal
          title="Switch to All eligible respondents?"
          message="Your custom base name and conditions will be kept while you're editing, but the chart won't use them unless you switch back to Custom base before saving."
          cancelButtonText="Cancel"
          confirmButtonText="Switch"
          onCancel={onCancel}
          onConfirm={onConfirm}
        />
      </div>
    </Modal>
  );
};

export default DisableCustomBaseConfirmDialog;
